export function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof url != "undefined") {
      window.location = url;
    }
  };

  if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-18407746390/4Ey6CKGkg5sdENbWv8lE",
        value: 1.0,
        currency: "INR",
        event_callback: callback,
      });
  }

  return false;
}
